import { BeatLoader } from 'react-spinners'

const LoadingIndicator = () => <BeatLoader color="silver" />

export default LoadingIndicator
